<template>
  <div>
    <el-header style="height:40px;">
      <el-page-header @back="goBack" content="题库组卷">
      </el-page-header>
    </el-header>
    <el-form :model="paper" ref="ruleForm" label-width="300px" class="demo-ruleForm">
      <el-form-item label="试卷名称" required>
        <el-input v-model="paper.name" style="width: 50%"></el-input>
      </el-form-item>
      <el-form-item label="生成套数"  required>
        <el-input v-model="paper.unit" style="width: 50%"></el-input>
      </el-form-item>
            <el-form-item :key="key" :label="typeValue[item.type]+'共('+item.sum_count+')题,选'" v-for="(item,key) in listData" required>
              <el-row>
                <el-col :span="12"><el-input v-model="paper.number[key]" style="width: 85%"></el-input>题，</el-col>
                <el-col :span="12">每题 <el-input v-model="paper.score[key]" style="width: 85%"></el-input>分</el-col>
              </el-row>
              <el-input type="hidden" v-model="paper.type[key]=item.type"  ></el-input>
            </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  const typeValue=[]
    export default {
        name: "autoQuestion",
        data() {
            return {
                listData: [],
                 typeValue,
                paper: {
                    name:'',
                    unit:'',
                    number:[],
                    score:[],
                    type:[]
                },
            };
        },
        created() {
            this.autoquestion()
        },
        methods: {
            goBack() {
                this.$router.back()
            },
            submitForm() {
                    if (this.paper.number.length<7) {
                        this.$message.error('请输入题目数量！')
                        return false
                    }  if (this.paper.score.length<7) {
                        this.$message.error('请输入每题分数！')
                        return false
                    }
                    this.$http.autoexam(this.paper).then(res=>{
                        this.$message.success('组卷成功')
                    })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            autoquestion() {
                this.$http.autoquestion().then(res => {
                    this.listData = res.data.data;
                    for (var i in res.data.typeValue) {
                        typeValue[i] = res.data.typeValue[i]
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/theoryManage/autoQuestion.vue